export default __webpack_public_path__ + "static/media/schedulingIcon.9e1bf5f1.svg";